export default function MatchMedia(...mediaQueries) {
  return mediaQueries
    .map(query => query.split(" ").pop())
    .every(query => window.matchMedia(query).matches);
}
